<coso-page-header [title]="title"></coso-page-header>
@if ({ isLoading: loadingService.isSpinnerActive$('saveSettings') | async }; as loadingState) { @if (!loadingState.isLoading) { @if (hasSettingsChanged$ | async) {
<alert type="warning">
  <coso-alert-message> You have pending changes that will be applied once you restart the replication process. </coso-alert-message>
</alert>
} } }
